module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('ul', {
    staticClass: "vm-select-group__wrap"
  }, [_c('li', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.visible),
      expression: "visible"
    }],
    staticClass: "vm-select-group__title"
  }, [_vm._v(_vm._s(_vm.label))]), _vm._v(" "), _c('li', [_c('ul', {
    staticClass: "vm-select-group"
  }, [_vm._t("default")], 2)])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-cb670e60","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/option-group.vue
// module id = 40
// module chunks = 0